import actions from '../actionTypes';
import * as Constants from '../../utilities/constants/Constants';

const initialState = {
  selectedDefaultSize: 0,
  projectWidth: null,
  projectHeight: null,
  backupProjectSize: { width: null, height: null },
  unitSystem: 'Imperial',
  orientation: null,
  backgroundContrast: 'light',
  language: 'en',
  wallSizeChangedFlag: false,
  canvasWall: {
    canvasWallWidthInput: Constants.DEFAULT_WALL_WIDTH,
    canvasWallHeightInput: Constants.DEFAULT_WALL_HEIGHT,
    canvasWallWidth: Constants.DEFAULT_WALL_WIDTH,
    canvasWallHeight: Constants.DEFAULT_WALL_HEIGHT,
    canvasWallWidthValid: '',
    canvasWallHeightValid: '',
    canvasWallWidthErrorMessage: '',
    canvasWallHeightErrorMessage: '',
    canvasWallActiveErrorMessage: ''
  },
  customWall: {
    customWidthInput: '',
    customHeightInput: '',
    customWidth: '',
    customHeight: '',
    widthValid: '',
    heightValid: '',
    widthErrorMessage: '',
    heightErrorMessage: '',
    activeErrorMessage: ''
  },
  selectedProduct: null,
  viewOnlyMode: false,
  canvasType: '',
  multiCanvasPopoverStatus: false,
  multiCanvas: {
    row: 1,
    rowInput: 1,
    rowValid: '',
    column: 1,
    columnInput: 1,
    columnValid: '',
    rowErrorMessage: '',
    colErrorMessage: '',
    multiCanvasErrorMessage: ''
  },
  validProject: false
};

export default function homeReducer(state = initialState, action) {
  switch (action.type) {
    case actions.SELECT_DEFAULT_WALL_CHANGE:
      return { ...state, selectedDefaultSize: action.payload.selectedSize };
    case actions.SELECT_CUSTOM_WALL_WIDTH:
      return {
        ...state,
        customWall: {
          ...state.customWall,
          customWidthInput: action.payload.widthInput,
          customWidth: action.payload.value,
          widthValid: action.payload.widthValid,
          widthErrorMessage: action.payload.widthErrorMessage
        }
      };
    case actions.SELECT_CUSTOM_WALL_HEIGHT:
      return {
        ...state,
        customWall: {
          ...state.customWall,
          customHeightInput: action.payload.heightInput,
          customHeight: action.payload.value,
          heightValid: action.payload.heightValid,
          heightErrorMessage: action.payload.heightErrorMessage
        }
      };
    case actions.CUSTOM_WALL_ERROR:
      return {
        ...state,
        customWall: {
          ...state.customWall,
          activeErrorMessage: action.payload.errorMessage
        }
      };
    case actions.SET_PROJECT_SIZE:
      return {
        ...state,
        projectWidth: action.payload.width,
        projectHeight: action.payload.height
      };

    case actions.SET_BACKUP_PROJECT_SIZE:
      return {
        ...state,
        backupProjectSize: {
          ...state.backupProjectSize,
          width: action.payload.width,
          height: action.payload.height
        }
      };

    case actions.UNIT_SYSTEM_CHANGED:
      return {
        ...state,
        unitSystem: action.payload.unitSystem
      };

    case actions.CONTRAST_CHANGED:
      return {
        ...state,
        backgroundContrast: action.payload.backgroundContrast
      };

    case actions.LANGUAGE_CHANGED:
      return {
        ...state,
        language: action.payload.language
      };

    case actions.ORIENTATION_CHANGED:
      return {
        ...state,
        orientation: action.payload.orientation
      };
    case actions.WALL_SIZE_CHANED_FLAG:
      return {
        ...state,
        wallSizeChangedFlag: action.payload.value
      };
    case actions.ENTER_VIEW_ONLY_PREVIEW_MODE:
      return {
        ...state,
        viewOnlyMode: action.payload.value
      };

    case actions.SET_SELECTED_PRODUCT:
      return {
        ...state,
        selectedProduct: action.payload.selectedProduct
      };

    case actions.SET_CANVAS_TYPE:
      return {
        ...state,
        canvasType: action.payload.canvasType
      };

    case actions.SET_CANVAS_WALL_WIDTH:
      return {
        ...state,
        canvasWall: {
          ...state.canvasWall,
          canvasWallWidthInput: action.payload.widthInput,
          canvasWallWidth: action.payload.canvasWallWidth
        }
      };

    case actions.SET_CANVAS_WALL_HEIGHT:
      return {
        ...state,
        canvasWall: {
          ...state.canvasWall,
          canvasWallHeightInput: action.payload.heightInput,
          canvasWallHeight: action.payload.canvasWallHeight
        }
      };

    case actions.SET_CANVAS_WALL_WIDTH_VALID:
      return {
        ...state,
        canvasWall: {
          ...state.canvasWall,
          canvasWallWidthValid: action.payload.valid,
          canvasWallWidthErrorMessage: action.payload.widthErrorMessage
        }
      };

    case actions.SET_CANVAS_WALL_HEIGHT_VALID:
      return {
        ...state,
        canvasWall: {
          ...state.canvasWall,
          canvasWallHeightValid: action.payload.valid,
          canvasWallHeightErrorMessage: action.payload.heightErrorMessage
        }
      };
    case actions.SET_CANVAS_WALL_ERROR:
      return {
        ...state,
        canvasWall: {
          ...state.canvasWall,
          canvasWallActiveErrorMessage: action.payload.errorMessage
        }
      };
    case actions.SET_MULTICANVAS_POPOVER_STATUS:
      return {
        ...state,
        multiCanvasPopoverStatus: action.payload.status
      };
    case actions.SET_ROW:
      return {
        ...state,
        multiCanvas: {
          ...state.multiCanvas,
          rowInput: action.payload.rowInput,
          row: action.payload.value
        }
      };

    case actions.SET_COLUMN:
      return {
        ...state,
        multiCanvas: {
          ...state.multiCanvas,
          columnInput: action.payload.columnInput,
          column: action.payload.value
        }
      };

    case actions.SET_MULTI_CANVAS_ERROR:
      return {
        ...state,
        multiCanvas: {
          ...state.multiCanvas,
          multiCanvasErrorMessage: action.payload.errorMessage
        }
      };

    case actions.SET_COLUMN_VALID:
      return {
        ...state,
        multiCanvas: {
          ...state.multiCanvas,
          columnValid: action.payload.columnValid,
          colErrorMessage: action.payload.colErrorMessage
        }
      };

    case actions.SET_ROW_VALID:
      return {
        ...state,
        multiCanvas: {
          ...state.multiCanvas,
          rowValid: action.payload.rowValid,
          rowErrorMessage: action.payload.rowErrorMessage
        }
      };
    case actions.SET_VALID_PROJECT:
      return {
        ...state,
        validProject: action.payload.status
      };
    case actions.SET_WIDTH_SIZE_VALIDATIONS:
      return {
        ...state,
        customWall: {
          ...state.customWall,
          widthValid: action.payload.widthValid,
          widthErrorMessage: action.payload.widthErrorMessage
        },
        canvasWall: {
          ...state.canvasWall,
          canvasWallWidthValid: action.payload.wallWidthValid,
          canvasWallWidthErrorMessage: action.payload.wallWidthErrorMessage
        },
        multiCanvas: {
          ...state.multiCanvas,
          columnValid: action.payload.columnValid,
          colErrorMessage: action.payload.colErrorMessage
        }
      };
    case actions.SET_HEIGHT_SIZE_VALIDATIONS:
      return {
        ...state,
        customWall: {
          ...state.customWall,
          heightValid: action.payload.heightValid,
          heightErrorMessage: action.payload.heightErrorMessage
        },
        canvasWall: {
          ...state.canvasWall,
          canvasWallHeightValid: action.payload.wallHeightValid,
          canvasWallHeightErrorMessage: action.payload.wallHeightErrorMessage
        },
        multiCanvas: {
          ...state.multiCanvas,
          rowValid: action.payload.rowValid,
          rowErrorMessage: action.payload.rowErrorMessage
        }
      };

    default:
      return state;
  }
}
